const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || '';

function hasGtag() {
    return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

export function isAnalyticsEnabled() {
    return Boolean(GA_MEASUREMENT_ID);
}

export function trackEvent(eventName, params = {}) {
    if (!hasGtag()) return;
    window.gtag('event', eventName, params);
}

export function trackCheckoutStarted({ productSlug, productId, source, feature, hasDeviceCode }) {
    trackEvent('portal_checkout_started', {
        product_slug: productSlug,
        product_id: productId,
        source: source || 'license-portal',
        feature: feature || undefined,
        device_code_present: hasDeviceCode ? 'true' : 'false',
    });
}

export function trackPurchaseReady({ productSlug, productId, source, feature, hasDeviceCode }) {
    trackEvent('portal_purchase_ready', {
        product_slug: productSlug,
        product_id: productId,
        source: source || 'license-portal',
        feature: feature || undefined,
        device_code_present: hasDeviceCode ? 'true' : 'false',
    });
}

export function trackActivationEvent(action, { productSlug, productName, source, feature }) {
    trackEvent('portal_activation_action', {
        action,
        product_slug: productSlug || undefined,
        product_name: productName || undefined,
        source: source || 'license-portal',
        feature: feature || undefined,
    });
}
